import {AbstractControl, FormArray, ValidationErrors, ValidatorFn} from "@angular/forms";

export function MustNotMatch(controlName: string, matchingControlName: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const control = group.get(controlName);
    const matchingControl = group.get(matchingControlName);

    if (!control || !matchingControl) {
      return null; // If controls are not found, validation passes
    }

    if (control.value && control.value === matchingControl.value) {
      matchingControl.setErrors({mustNotMatch: true});
      control.setErrors({mustNotMatch: true});
    } else {
      if (matchingControl.errors && matchingControl.errors["mustNotMatch"]) {
        delete matchingControl.errors["mustNotMatch"];
        if (Object.keys(matchingControl.errors).length === 0) {
          matchingControl.setErrors(null);
        }
      }
      if (control.errors && control.errors["mustNotMatch"]) {
        delete control.errors["mustNotMatch"];
        if (Object.keys(control.errors).length === 0) {
          control.setErrors(null);
        }
      }
    }

    return null;
  };
}


export function dateRangeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || value.length !== 2 || !value[0] || !value[1]) {
      return {dateRangeInvalid: true};
    }
    return null;
  };
}

export function findMenuFromMenuList(menuList: any[], bookmarkId: string | undefined) {
  function findMenu(menu: any[], bookmarkId: string | undefined): any | null {
    for (const item of menu) {
      if (item.bookMarkUniqueId === bookmarkId) {
        return item; // Return the matched item
      } else if (item.child && item.child.length > 0) {
        const childItem = findMenu(item.child, bookmarkId);
        if (childItem) {
          return childItem; // Return the matched child item
        }
      }
    }
    return null; // Return null if not found
  }

  return findMenu(menuList, bookmarkId);
}

export function latitudeLongitudeValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const latitude = group.get('latitude');
    const longitude = group.get('longitude');

    if (latitude && longitude) {
      const latitudeValue = latitude.value;
      const longitudeValue = longitude.value;

      if (latitudeValue && !longitudeValue) {
        longitude.setErrors({requiredIfLatitude: true});
        return null;
      } else if (!latitudeValue && longitudeValue) {
        latitude.setErrors({requiredIfLongitude: true});
        return null;
      } else {
        latitude.setErrors(null);
        longitude.setErrors(null);
      }
    }
    return null;
  };
}
export function uniqueDescriptionValidator(formArray: AbstractControl): ValidationErrors | null {
  if (formArray instanceof FormArray) {
    const descriptions = formArray.controls.map(control => control.get('description')?.value.trim());

    descriptions.forEach((desc, index) => {
      const duplicates = descriptions.filter((d, i) => d === desc && i !== index);
      const control = formArray.at(index).get('description');
      if (control) {
        if (duplicates.length) {
          control.setErrors({ uniqueDescription: true });
        } else {
          if (control.hasError('uniqueDescription')) {
            delete control.errors!['uniqueDescription'];
            if (!Object.keys(control.errors!).length) {
              control.setErrors(null);
            }
          }
        }
      }
    });
  }
  return null;
}
